import { createObject } from 'src/utils/objects'

const makeReportCode = (billingCode, teamId) => `${billingCode}/${teamId}`

const teams = {
  getTemplate(key) {
    const map = {
      'all-teams': () => ({ teamCode: '-1', teamId: '-1', teamName: 'All Teams' }),
      'unknown-team': () => ({ teamCode: '-2', teamId: '-2', teamName: 'Team Unknown' }),
    }

    return map[key]()
  },

  getTeamName(networkTeamId, publisher, team = {}) {
    const { isProcessed, teamName = `Team ${networkTeamId}` } = team

    if (isProcessed) return teamName

    const invalidTeamId = !networkTeamId && networkTeamId !== 0
    const { name: publisherName, clientName } = publisher

    if (!publisherName && clientName) return `${clientName}: All Access`
    if (invalidTeamId) return `${publisherName}: Team Unknown`
    if (networkTeamId === '-1') return `${publisherName}`

    return `${publisherName}: ${teamName}`
  },
  /**
   * Transforms a publisher's team into a team option.
   * @param {Object} publisher A publisher's organization.
   * @param {Object} publisherTeam A publisher's team from the API.
   * @returns {*}
   */
  mapTeamOption(publisher, publisherTeam) {
    const { teamCode = publisherTeam.code, teamId = publisherTeam.id } = publisherTeam
    const team = createObject(publisher, publisherTeam)
    const { billingCode } = publisher

    const teamName = this.getTeamName(teamId, publisher, team)
    const reportCode = makeReportCode(billingCode, teamId)

    team.code = teamCode
    team.id = teamId

    team.teamCode = teamCode
    team.teamId = teamId
    team.teamName = teamName

    team.reportCode = reportCode
    team.href = `/internal/organization/${reportCode}`

    team.associationId = billingCode
    team.subId = String(teamId)

    team.isAllAccess = ['-1', 'all-secondary'].includes(String(teamId))

    team.hasHealthAdx = publisher.hasHealthAdx
    team.hasHealthNetwork = publisher.hasHealthNetwork
    team.hasYieldPartner = publisher.hasYieldPartner

    team.operator = 'incl'
    team.text = teamName
    team.value = teamId

    team.isProcessed = true

    return team
  },
}

export default teams
